import { create } from 'zustand';

import { DatasetSchema } from '@/types/schema';
import { createName } from '@/utils/create-name';

interface DatasetDetailsState {
  name: string;
  description: string;
  setName: (name: string) => void;
  setDescription: (description: string) => void;
  error: string | undefined;
  setError: (error: string | undefined) => void;
  reset: (dataset?: DatasetSchema) => void;
}

export const useDatasetDetails = create<DatasetDetailsState>((set) => {
  return {
    name: createName('ds'),
    description: '',
    setName: (name: string) => {
      if (!name) {
        return set({ error: 'Name is required', name });
      }
      if (name.trim() === '') {
        return set({ error: 'Name cannot consist only of whitespace', name });
      }
      return set(() => ({ name, error: undefined }));
    },
    setDescription: (description: string) => set(() => ({ description })),
    error: undefined,
    setError: (error: string | undefined) => set(() => ({ error })),
    reset: (dataset?: DatasetSchema) => {
      set({
        name: dataset?.name ?? createName('ds'),
        description: dataset?.description ?? '',
      });
    },
  };
});
